/** Flags are evaluated for the signed-in user, never the acting stakeholder. */
export const FEATURE_ENABLED_QUERY_KEY = 'feature-enabled';
